(function () {
  function removeLeakedSchemaText(root) {
    if (!root) return false;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var removedAny = false;

    while (walker.nextNode()) {
      var node = walker.currentNode;
      var value = node.nodeValue;
      if (!value) continue;

      var trimmed = value.trim();
      if (!trimmed) continue;

      var looksLikeSchema =
        (trimmed.indexOf('{"@context"') === 0 || trimmed.indexOf('{\\"@context\\"') === 0) &&
        (trimmed.indexOf('"@type":"ProductGroup"') !== -1 ||
          trimmed.indexOf('"@type":"Product"') !== -1 ||
          trimmed.indexOf('\\"@type\\":\\"ProductGroup\\"') !== -1 ||
          trimmed.indexOf('\\"@type\\":\\"Product\\"') !== -1);

      if (!looksLikeSchema) continue;

      if (node.parentNode) {
        node.parentNode.removeChild(node);
        removedAny = true;
      }
    }

    return removedAny;
  }

  function runFix() {
    var productRoot = document.querySelector('[id^="MainProduct-"]') || document.body;
    removeLeakedSchemaText(productRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFix);
  } else {
    runFix();
  }

  window.addEventListener('load', runFix);
})();
